var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.571 13.429H3.43q-.607 0-1.018-.411A1.38 1.38 0 0 1 2 12q0-.607.41-1.018.412-.41 1.019-.41h7.142V3.428q0-.607.411-1.018Q11.392 2 12 2q.607 0 1.018.41.41.412.41 1.019v7.142h7.143q.607 0 1.018.411Q22 11.392 22 12q0 .607-.41 1.018-.411.41-1.019.41H13.43v7.143q0 .607-.411 1.018Q12.608 22 12 22q-.607 0-1.018-.41a1.38 1.38 0 0 1-.41-1.019z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOutline);
export default __webpack_public_path__ + "static/media/add_outline.3a515528282eef1fc0ab5d9b1baf4b5e.svg";
export { ForwardRef as ReactComponent };